import React, { useState } from 'react';
import axios from 'axios';
import { BASE_API_URL } from '../../constant';

function formatDateToDDMMYYYY(timestamp) {
    const date = new Date(timestamp);
    const day = date.getUTCDate().toString().padStart(2, '0');
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = date.getUTCFullYear();

    return `${day}-${month}-${year}`;
}

function formatAMPM(datetime) {
    var timestamp = new Date(datetime);
    var hours = timestamp.getHours();
    var minutes = timestamp.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
}

function ShowWinningNumbers() {
    const [data, setData] = useState([]);

    axios.get(`${BASE_API_URL}api/winning/winning_numbers`)
        .then(res => {
            setData(res.data);
        })
        .catch(err => {
            console.log(err);
        });

    return (
        <div>
            <h1>Winning Numbers</h1>
            <table className="table">
                <thead>
                    <tr>
                        <th>Sl No.</th>
                        <th>Date | Time</th>
                        <th>Winning Number</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={item._id}>
                            <td>{index + 1}</td>
                            <td>{formatDateToDDMMYYYY(item.created_date_time) + " " + formatAMPM(item.created_date_time) }</td>
                            <td>{item.winning_number}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ShowWinningNumbers;
